var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignalC(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.999 511.999",
    style: {
      enableBackground: "new 0 0 511.999 511.999"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5050"
    },
    d: "M207.702,312.83c-2.185,0-4.369-0.833-6.036-2.501c-29.956-29.956-29.956-78.704,0-108.659 c3.335-3.335,8.737-3.335,12.072,0s3.335,8.737,0,12.072c-23.303,23.303-23.303,61.212,0,84.515c3.335,3.335,3.335,8.738,0,12.072 C212.07,311.997,209.886,312.83,207.702,312.83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5050"
    },
    d: "M304.297,312.83c-2.185,0-4.369-0.833-6.036-2.501c-3.335-3.335-3.335-8.737,0-12.072 c23.303-23.303,23.303-61.212,0-84.515c-3.335-3.335-3.335-8.738,0-12.072c3.335-3.335,8.738-3.335,12.072,0 c29.956,29.955,29.956,78.704,0,108.659C308.666,311.997,306.481,312.83,304.297,312.83z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8269"
    },
    d: "M340.515,349.052c-2.185,0-4.369-0.833-6.036-2.501c-3.335-3.335-3.335-8.737,0-12.072 c31.44-31.444,41.095-78.446,24.587-119.744c-1.751-4.378,0.383-9.346,4.761-11.096c4.369-1.734,9.346,0.379,11.096,4.761 c19.043,47.647,7.904,101.878-28.372,138.153C344.883,348.218,342.699,349.052,340.515,349.052z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8269"
    },
    d: "M349.91,190.573c-2.526,0-5.027-1.113-6.711-3.247c-2.692-3.418-5.627-6.716-8.721-9.801 c-3.335-3.331-3.335-8.737-0.009-12.072c3.335-3.343,8.745-3.335,12.08-0.009c3.56,3.56,6.945,7.361,10.055,11.301 c2.918,3.702,2.285,9.071-1.417,11.993C353.621,189.972,351.762,190.573,349.91,190.573z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAF91"
    },
    d: "M129.223,391.309c-2.185,0-4.369-0.833-6.036-2.501c-73.226-73.23-73.226-192.386,0-265.617 c3.335-3.335,8.737-3.335,12.072,0c3.335,3.335,3.335,8.737,0,12.072c-66.573,66.573-66.573,174.899,0,241.472 c3.335,3.335,3.335,8.738,0,12.073C133.591,390.476,131.408,391.309,129.223,391.309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAF91"
    },
    d: "M382.776,391.309c-2.184,0-4.369-0.833-6.036-2.501c-3.335-3.335-3.335-8.738,0-12.073 c66.573-66.573,66.573-174.899,0-241.472c-3.335-3.335-3.335-8.737,0-12.072c3.335-3.335,8.738-3.335,12.073,0 c73.226,73.23,73.226,192.386,0,265.617C387.145,390.476,384.96,391.309,382.776,391.309z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD2BE"
    },
    d: "M80.934,439.603c-2.184,0-4.369-0.833-6.036-2.501c-99.864-99.859-99.864-262.345,0-362.204 c3.335-3.335,8.737-3.335,12.072,0c3.335,3.335,3.335,8.737,0,12.072c-93.202,93.202-93.202,244.857,0,338.06 c3.335,3.335,3.335,8.738,0,12.072C85.303,438.77,83.118,439.603,80.934,439.603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD2BE"
    },
    d: "M431.065,439.603c-2.185,0-4.369-0.833-6.036-2.501c-3.335-3.335-3.335-8.737,0-12.072 c93.202-93.202,93.202-244.857,0-338.06c-3.335-3.335-3.335-8.737,0-12.072c3.335-3.335,8.738-3.335,12.072,0 c99.864,99.859,99.864,262.345,0,362.204C435.434,438.77,433.25,439.603,431.065,439.603z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8269"
    },
    d: "M145.006,308.975c-3.385,0-6.595-2.034-7.929-5.373c-19.043-47.647-7.903-101.878,28.372-138.153 c3.335-3.335,8.737-3.335,12.072,0c3.335,3.335,3.335,8.737,0,12.072c-31.44,31.444-41.095,78.446-24.587,119.744 c1.751,4.378-0.383,9.346-4.761,11.096C147.131,308.775,146.064,308.975,145.006,308.975z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8269"
    },
    d: "M171.484,349.052c-2.184,0-4.369-0.833-6.036-2.497c-3.56-3.56-6.945-7.361-10.055-11.301 c-2.918-3.702-2.285-9.071,1.417-11.993c3.711-2.918,9.071-2.281,11.989,1.413c2.692,3.418,5.627,6.716,8.721,9.801 c3.335,3.331,3.335,8.737,0.009,12.072C175.862,348.218,173.669,349.052,171.484,349.052z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF5050"
    },
    cx: 256.003,
    cy: 256.004,
    r: 25.612
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignalC);
export default __webpack_public_path__ + "static/media/signal_c.965da79eec1745b68b0ee4d6f0610448.svg";
export { ForwardRef as ReactComponent };